import { Button, Grid, Typography } from '@mui/material'

import errorImage from '../../images/error-image.svg'
import Api from '../../utils/api'
import { AUTH_TOKEN } from '../../utils/constants'
import Header from '../header'

import useStyles from './index.styles'

interface IProps {
  errorMessage: string
}

const ErrorBoundaryContent = (props: IProps) => {
  const { errorMessage } = props

  const classes = useStyles

  return (
    <main>
      <Header />

      <Grid container={true} sx={classes.errorGridContainer}>
        <Grid size={12} container={true} sx={classes.imageGrid}>
          <img src={errorImage} alt="error" aria-label="Error" />
        </Grid>

        <Grid container={true} sx={classes.typographyWrapper} size={12}>
          <Typography variant="body1" color="text.secondary">
            Having trouble loading this screen. Please try again.
          </Typography>

          {errorMessage && (
            <Grid size={12}>
              <Typography variant="body2" color="text.secondary">
                {errorMessage}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container={true} sx={classes.buttonsRow} size={12}>
          <Button onClick={() => window.location.reload()}>Refresh Page</Button>

          <Button
            onClick={async () => {
              const res = await Api.get('/api/logout')
              if (res.ok) {
                localStorage.removeItem(AUTH_TOKEN)
                window.location.href = '/login'
              }
            }}
          >
            Logout
          </Button>
        </Grid>
      </Grid>
    </main>
  )
}

export default ErrorBoundaryContent
